import { sortBy } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetPayersByAccountQuery } from "store/queries/payers";
import {
  onPayerNameLoad,
  onPayerCodeLoad,
  onPayerTypeLoad,
} from "store/slices/order";

import { useQuery } from "./useQuery";

export function usePayerInformation(id?: string) {
  const dispatch = useDispatch();
  const {
    payersNameInfo = [],
    payersCodesInfo = [],
    payersTypeInfo = [],
  } = useSelector((state: any) => state.orderSlice);
  const query = useQuery();
  const accountId = query.get("accountId") || id || "";

  const { data: payerByAccount, isLoading: loadingPayersByAccount } =
    useGetPayersByAccountQuery(accountId, {
      skip: !accountId,
    });

  const payersName = payerByAccount;

  const generateNameOptions = () => {
    return payersName?.data.map((item: { [x: string]: any; id: any }) => {
      return {
        name: item.name,
        value: { name: item.name, payerId: item.id },
        type: item.type,
      };
    });
  };

  const payerNameCodes =
    payersName?.data.map((payer: any) => ({
      name: payer.name,
      code: payer.pverifyId,
    })) || [];

  const payerTypeCodes =
    payersName?.data.map((payer: any) => ({
      name: payer.name,
      type: payer.type,
    })) || [];

  useEffect(() => {
    if (payersName) {
      const generatedPayersName = generateNameOptions();
      dispatch(onPayerNameLoad(generatedPayersName));
      dispatch(onPayerCodeLoad(payerNameCodes));
      dispatch(onPayerTypeLoad(payerTypeCodes));
    }
  }, [payersName, dispatch]);

  return {
    payerNameOptions: sortBy(payersNameInfo, ["name"]),
    payerNameCodes: sortBy(payersCodesInfo, ["name"]),
    payerTypeCodes: sortBy(payersTypeInfo, ["name"]),
    loadingPayersName: loadingPayersByAccount,
  };
}
